import { render, staticRenderFns } from "./FeedbackList.vue?vue&type=template&id=10094eb4&scoped=true"
import script from "./FeedbackList.vue?vue&type=script&lang=js"
export * from "./FeedbackList.vue?vue&type=script&lang=js"
import style0 from "./FeedbackList.vue?vue&type=style&index=0&id=10094eb4&prod&lang=stylus&scoped=true"
import style1 from "./FeedbackList.vue?vue&type=style&index=1&id=10094eb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10094eb4",
  null
  
)

export default component.exports